import { defineComponent as _defineComponent } from 'vue'
import { reactive, ref, watch } from '@nuxtjs/composition-api';
import { onClickOutside } from '@vueuse/core';
import { useOpenClose } from '~/composables';

interface Props {
  value?: any;
  items?: any[];
}
interface Emits {
  (e: 'input', data: any): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CatalogFilterHeaderSorting',
  props: {
    value: { default: () => ({}) },
    items: { default: () => [
    { text: 'Featured', name: 'order[best_seller]' },
    { text: 'Newest', name: 'order[new]' },
  ] }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', data: any): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: any, items: any[] };




const { isOpen, open, close } = useOpenClose();
const wrap = ref();
const sorting = reactive<{
  field?: string;
  order?: string;
}>({
  field: undefined,
  order: undefined,
});

const toggleOpenClose = () => {
  isOpen.value ? close() : open();
};

const getSortingOrder = (order: any) => {
  if (order !== sorting.field) return 'desc';
  return undefined;
};

const changeOrder = (field: any) => {
  const order = getSortingOrder(field);

  emit('input', { ...(order && { [field]: order }) });
  close();
};

onClickOutside(wrap, () => close());

watch(
  () => props.value,
  (value) => {
    let field;
    let order;

    if (value) [field, order] = Object.entries(value)[0] ?? [];

    sorting.field = field;
    sorting.order = order as any;
  },
  { immediate: true },
);

return { __sfc: true,props, emit, isOpen, open, close, wrap, sorting, toggleOpenClose, getSortingOrder, changeOrder }
}

})